function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "photos_icon",
  "data-name": "photos icon",
  d: "M1075.1,6049a2.084,2.084,0,0,1-2.1-2.06v-9.271a2.085,2.085,0,0,1,2.1-2.06h.536a.127.127,0,0,0,.024,0h.023a.905.905,0,0,0,.812-.542l0-.012a.361.361,0,0,0,.018-.049l.159-.416a.931.931,0,0,1,.829-.584h1.292a.931.931,0,0,1,.829.584l.167.433a.007.007,0,0,0,0,0,.9.9,0,0,0,.827.581.127.127,0,0,0,.024,0h9.242a2.086,2.086,0,0,1,2.1,2.06v9.271a2.086,2.086,0,0,1-2.1,2.06Zm3.731-6.557a4.481,4.481,0,1,0,4.48-4.4A4.439,4.439,0,0,0,1078.836,6042.447Zm9.572-4.361a1.007,1.007,0,1,0,1.008-.988A1,1,0,0,0,1088.408,6038.086Zm-7.918,4.363a2.831,2.831,0,1,1,2.83,2.781A2.806,2.806,0,0,1,1080.49,6042.449Z",
  transform: "translate(-1073.008 -6034.01)",
  fill: "#ccc"
});

var SvgFooterCamera = function SvgFooterCamera(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18.984,
    height: 14.994,
    viewBox: "0 0 18.984 14.994",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgFooterCamera, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/footer-camera.7af547bb.svg";
export { ForwardRef as ReactComponent };